<template>
  <el-card>
    <p class="info">
      You're using the free version of Youmi Offer Detect.We suggest that the results are only used
      to evaluate APP offers
    </p>
    <euler source="youmi-offers"></euler>
  </el-card>
</template>

<script>
import euler from '../../../../euler/src/euler'
export default {
  components: {
    euler,
  },
  data() {
    return {}
  },
}
</script>
